
/**
* @ngdoc controllers
* @name controllers.LoginJWT
*
* @description
* 1. Handles login with JWT token
*
* @param {any} $stateParams $stateParams
* @param {any} Auth service used to login the user
*/
angular.module('controllers')
    .controller('LoginJWT', (
        $stateParams, $rootScope, $location,
        Auth, JWT, Sso, ErrorHandler,
    ) => {

        const hash = $location.hash();

        // stores all URL params
        $rootScope.loginJWTUrlParams = $stateParams.options;
        $rootScope.currentUrl = $location.url();

        if (hash) {

            $rootScope.urlHash = hash;

        }

        Auth.loginSource = 'Token';
        Auth.loginType = 'Token';

        let { token } = $stateParams;
        const tokenPayload = JWT.getTokenPayload(token);

        // if the JWT token received is not for the dashboard we need to get one for the dashboard
        // this happens after a user purchase and comes with a token from MYA
        if (!tokenPayload.cid || tokenPayload.cid !== 'dashboard') {

            // setting the token on a cookie so that it can be read from by the baseRestService
            const data = {
                data: {
                    access_token: token,
                },
            };

            Auth.setLoginCookies(data);
            Sso
                .getClientToken('dashboard')
                .then((response) => {

                    token = response.data.access_token;

                    Auth.loginWithToken(token);

                })
                .catch((exception) => {

                    const errorLocation = 'loginJwt.Sso.getClientToken Error';

                    ErrorHandler.handleError(exception, errorLocation);

                });

        } else {

            Auth.loginWithToken(token);

        }

    });



// WEBPACK FOOTER //
// ./scripts/controllers/auth/loginjwt.js